import * as React from 'react';

const IconMenuVertical = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M11.987 23.218a2.623 2.623 0 002.625-2.622 2.623 2.623 0 00-2.625-2.62 2.623 2.623 0 00-2.625 2.62 2.623 2.623 0 002.625 2.622zM11.987 5.995a2.623 2.623 0 002.625-2.621A2.623 2.623 0 0011.987.753a2.623 2.623 0 00-2.625 2.621 2.623 2.623 0 002.625 2.621zM11.987 14.606a2.623 2.623 0 002.625-2.621 2.623 2.623 0 00-2.625-2.621 2.623 2.623 0 00-2.625 2.62 2.623 2.623 0 002.625 2.622z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconMenuVertical;
